<!-- 重仓股持仓列表 -->
<template>
  <div class="heavy-stock-list">
    <!-- 顶部重仓 -->
    <div class="top row">
      <p class="top-tip"><span class="dot"></span>
        <span
        >重仓股票</span><span class="stock-value">{{dataSource.allHoldRatio || '--'}}</span>
      </p>
      <div class="date">{{dataSource.holdDate || '--'}}</div>
    </div>
    <div v-if="showOversea" class="oversea row">
      <img :src="ALERT_ICON" />
      <div>{{overseaInfo.delayText}}</div>
    </div>
    <!-- 持仓列表 -->
    <common-list
      :header-list="headerList"
      :data-source="getDataList()"
      :more-text="'更多持仓信息'"
      :click-track="'xpzy.pzy.gdccxx.click'">
      <template slot="top-extra">
        <div class="hold-count-desc">连续持有季度</div>
      </template>
      <template slot="list-item" slot-scope="{item}">
        <div class="row list-item" @click="$goFundApp">
          <!-- 股票名称 -->
          <div class="stock-name">
            <div>{{item.stockName}}</div>
            <div class="row stock-tags">
              <div v-if="!$isEmpty(item.marketTag)" class="market-tag">{{item.marketTag}}</div>
              <div v-if="!$isEmpty(item.indexName)" class="index-tag">{{item.indexName}}</div>
            </div>
          </div>
          <!-- 价格信息 -->
          <div class="price-column">
            <div v-if="!$isEmpty(item.marketTip)" class="price-tip">{{item.marketTip}}</div>
            <div :style="{ color: getRateColor(item.priceRatio)}" class="price-tip"
              >{{item.price || '--'}}</div>
            <div :style="{ color: getRateColor(item.priceRatio) }" class="price-ratio"
              >{{item.priceRatio || '--'}}</div>
          </div>
          <!-- 持仓占比 -->
          <div class="hold-column">{{item.holdRatio}}</div>
          <div class="last-column">
            <div class="previous-box row">
              <img v-if="['新增','不变'].indexOf(item.compareWithPrevious) < 0
                && !$isEmpty(item.compareWithPrevious)"
                :src="parseFloat(item.compareWithPrevious) > 0 ? UP_ARROW : DOWN_ARROW"
                class="arrow" />
              <div>{{getPreviousValue(item.compareWithPrevious)}}</div>
            </div>
            <div v-if="!$isEmpty(item.holdCount)" class="hold-count">{{item.holdCount}}</div>
          </div>
        </div>
      </template>
    </common-list>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CONFIG from '@/configs/default';
import tool from '@/utils/tool';
import CommonList from '../MarketQuotation/QuotationCommonList.vue';

export default {
  name: 'heavy-stock-list',

  components: {
    CommonList,
  },

  props: {
    dataSource: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      headerList: CONFIG.heavyStockListHeader || [],
      UP_ARROW: 'https://j5.dfcfw.com/sc/image/202208/20220815030116.png',
      DOWN_ARROW: 'https://j5.dfcfw.com/sc/image/202208/20220815030127.png',
      ALERT_ICON: 'https://j5.dfcfw.com/sc/image/202202/20220225093517.png',
    };
  },

  computed: {
    ...mapState('overseaInfo', ['isOversea', 'overseaInfo']), // 海外信息
    showOversea() {
      return this.isOversea && !this.$isEmpty(this.overseaInfo?.delayText);
    },
  },

  methods: {

    getRateColor: tool.getRateColor,

    getPreviousValue(value) {
      if (['新增', '不变'].indexOf(value) >= 0) return value;
      if (this.$isEmpty(value) || this.$isEmpty(parseFloat(value))) return '--';
      try {
        return `${Math.abs(parseFloat(value)).toFixed(2)}%`;
      } catch (error) {
        return '--';
      }
    },

    async getDataList() {
      return this.dataSource.list;
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.heavy-stock-list {
  width: 100%;
  box-sizing: border-box;
  padding-right: 24px;
  .top {
    justify-content: space-between;
    .top-tip {
      font-size: 30px;
      color: #000000;
      line-height: 38px;
      height: 38px;
      margin: 0;
      .dot {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: #f96b36;
        border-radius: 5px;
        margin-right: 8px;
        margin-bottom: 8px;
      }
      .stock-value {
        font-family: DINAlternate-Bold;
        font-size: 32px;
        color: #000000;
        letter-spacing: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 24px;
      }
    }
    .date {
      font-family: DINAlternate-Bold;
      font-size: 28px;
      color: #999999;
      letter-spacing: 0;
      text-align: right;
      line-height: 36px;
    }
  }
  .oversea {
    background-color: #FDF8F0;
    border: 1px solid #F7E6D3;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 12px;
    color: #ff4400;
    font-size: 28px;
    margin: 24px 0 24px;
    img {
      width: 26px;
      height: 26px;
      margin-right: 24px;
    }
  }
  .hold-count-desc {
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    text-align: right;
  }
  .list-item {
    justify-content: space-between;
    padding: 16px 0 24px;
    .stock-name {
      flex: 5;
      font-size: 30px;
      color: #000000;
      letter-spacing: 0;
      line-height: 30px;
      .stock-tags {
        justify-content: flex-start;
        .market-tag {
          margin-top: 8px;
          font-size: 24px;
          color: #666666;
          text-align: center;
          margin-right: 16px;
        }
        .index-tag {
          margin-top: 8px;
          background-color: rgba(102, 102, 102, 0.1);
          border-radius: 4px;
          font-size: 20px;
          color: #666666;
          text-align: center;
          padding: 4px 8px 4px 8px;
        }
      }
    }
    .price-column {
      flex: 4;
      font-family: DINAlternate-Bold;
      font-size: 32px;
      text-align: center;
      .price-tip {
        color: #000000;
      }
      .price-ratio {
        font-size: 26px;
        margin-top: 8px;
      }
    }
    .hold-column {
      flex: 3;
      font-family: DINAlternate-Bold;
      font-size: 32px;
      color: #000000;
      text-align: center;
    }
    .last-column {
      flex: 3;
      font-family: DINAlternate-Bold;
      font-size: 30px;
      color: #000000;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .previous-box {
        justify-content: flex-end;
        .arrow {
          width: 12px;
          height: 19px;
          margin-right: 8px;
        }
      }
      .hold-count {
        font-size: 20px;
        color: #666666;
        font-weight: 400;
        background: rgba(102, 102, 102,0.1);
        border-radius: 4px;
        padding: 4px 8px;
        margin-top: 12px;
      }
    }
  }
}
</style>
